import * as _ from 'underscore';
import * as Cookies from 'js-cookie';

export function Options(value: any){
    return function(target: any): any {
        let proto = target.prototype;
        proto.className       = value.className  !== undefined ? value.className  : proto.className;
        proto.template        = value.template   !== undefined ? value.template   : proto.template;
        proto.childView       = value.childView  !== undefined ? value.childView  : proto.chilldView;
        proto.el              = value.el         !== undefined ? value.el         : proto.el;
        proto.tagName         = value.tagName    !== undefined ? value.tagName    : proto.tagName;
        proto.controller      = value.controller !== undefined ? value.controller : proto.controller;

        proto.regions         = _.extend({}, proto.regions,         value.regions);
        proto.triggers        = _.extend({}, proto.triggers,        value.triggers);
        proto.ui              = _.extend({}, proto.ui,              value.ui);
        proto.childViewEvents = _.extend({}, proto.childViewEvents, value.childViewEvents);
        proto.bindings        = _.extend({}, proto.bindings,        value.bindings);
        proto.appRoutes       = _.extend({}, proto.appRoutes,       value.appRoutes);
    }
}

export function childView(eventName: string): any{
    return function(target, name, descriptor){
        if(!target.childViewEvents) {
            target.childViewEvents = {};
        }

        if(_.isFunction(target.childViewEvents)) {
            throw new Error('The "childView" decorator is not compatible with a childViewEvents method');
        }

        if(!eventName) {
            throw new Error('The "childView" decorator requires an eventName argument');
        }

        target.childViewEvents[eventName] = name;
        return descriptor;
    }
}

/**
 * Re-worked from (https://stackoverflow.com/questions/7944460/detect-safari-browser#answer-7944490)
 *
 */
function isSafari(): boolean{
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') === -1) {
            return true;
        }
    }
    return false;
}

/**
 * Uses LocalStorage API to mark the `privacy_accepted` as Safari just stores it for 24 hours
 */
export function markPrivacyAccepted(): void{
    // Use LocalStorage instead of Cookies for Safari
    if (isSafari()) {
        localStorage.setItem('privacy_accepted', 'true');
    } else {
        Cookies.set('privacy_accepted', 'true', { expires: 365 * 9 } );
    }
}

export function isPrivacyAccepted(): boolean{
    if (isSafari()) {
        return localStorage.getItem('privacy_accepted') != 'true';
    } else {
        return Cookies.get('privacy_accepted') != 'true';
    }
}

export function model(eventName: string): any{
    return function(target, name, descriptor){
        if(!target.modelEvents) {
            target.modelEvents = {};
        }

        if(_.isFunction(target.modelEvents)) {
            throw new Error('The on decorator is not compatible with an modelEvents method');
        }

        if(!eventName) {
            throw new Error('The on decorator requires an eventName argument');
        }

        target.modelEvents[eventName] = name;
        return descriptor;
    }
}

export function collection(eventName: string): any{
    return function(target, name, descriptor){
        if(!target.collectionEvents) {
            target.collectionEvents = {};
        }

        if(_.isFunction(target.collectionEvents)) {
            throw new Error('The on decorator is not compatible with an collectionEvents method');
        }

        if(!eventName) {
            throw new Error('The on decorator requires an eventName argument');
        }

        target.collectionEvents[eventName] = name;
        return descriptor;
    }
}


export function on(eventName: string): any{
    return function(target, name, descriptor){
        if(!target.events) {
            target.events = {};
        }

        if(_.isFunction(target.events)) {
            throw new Error('The on decorator is not compatible with an events method');
        }

        if(!eventName) {
            throw new Error('The on decorator requires an eventName argument');
        }

        target.events[eventName] = name;
        return descriptor;
    }
}

export function debounce(wait:number, immediate?:boolean): any {
    return function(target, name, descriptor) {
        descriptor.value = _.debounce(descriptor.value, wait, immediate);
        return descriptor;
    }
}

export function throttle(wait:number): any {
    return function(target, name, descriptor) {
        descriptor.value = _.throttle(descriptor.value, wait);
        return descriptor;
    }
}

export function memoize(): any {
    return function(target, name, descriptor) {
        descriptor.value = _.memoize(descriptor.value);
        return descriptor;
    }
}



// WEBPACK FOOTER //
// ./@modules/utils/decorators.ts